import { AfterViewInit, Directive, ElementRef } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';

const allValue = 999999;
const allValueLabel = 'All'; // or inject i18n service and get translation of "All" in directive constructor

@Directive({
  selector: '[mcAllItemsGrid]',
})
export class AllItemsGridDirective implements AfterViewInit {

  ngAfterViewInit() {
    this.host._changePageSize(this.host.pageSize);
  }

  public constructor(private readonly host: MatPaginator, private readonly elRef: ElementRef) {
    // @ts-ignore
    const proxiedUpdateDisplayedPageSizeOptions = host._updateDisplayedPageSizeOptions.bind(host);
    // @ts-ignore
    host._updateDisplayedPageSizeOptions = () => {
      proxiedUpdateDisplayedPageSizeOptions();
      // @ts-ignore
      const displayedPageSizeOptions = host._displayedPageSizeOptions;

      if (!displayedPageSizeOptions) return;

      const newDisplayedPageSizeOptions = [
        ...displayedPageSizeOptions.filter((x) => x !== allValue),
        allValueLabel,
      ];

      // @ts-ignore
      host._displayedPageSizeOptions = newDisplayedPageSizeOptions;
      // @ts-ignore
      host._changeDetectorRef.markForCheck();
    };

    const proxiedChangePageSize = host._changePageSize.bind(host);
    host._changePageSize = (v) => {
      // converting to number if value is string. We need to do so because whole paging logic depend that pageSize is a number.
      // @ts-ignore
      if (v === allValueLabel) v = allValue;

      proxiedChangePageSize(v);
      elRef.nativeElement.querySelector('.mat-mdc-select-value').innerText = v === allValue ? allValueLabel : v;
    };
  }
}
